module.exports = __webpack_public_path__ + "assets/img/btn-view-35e86bd4.png";